<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <svg-component @finished="$store.commit('nextShow', true)"/>

    
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 1/AUDIO 08'
    ]"></audio-player> 
  </div>
</template>

<script>
import SvgComponent from '../../assets/Modulo 1/diapositiva-7';
export default {
  components: {
    SvgComponent
  },
  data() {
    return {
      dialogos: [
        "Cumpliendo con la normatividad y basándose en los análisis económicos, el estudio de la disciplina de la geociencia y la ingeniería de yacimientos, ECOPETROL S.A. hace una estimación de volúmenes de reservas y recursos, luego determina un pronóstico de la producción que define planes de desarrollo y a su vez, proyecta unos ingresos futuros; lo que le permite calcular en pesos de hoy a cuánto equivalen esos ingresos futuros. <span class='instruccion'>Haz clic en los iconos.</span>" 
      ]
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  }
}
</script>
<style lang="scss" scoped>
</style>
